document.addEventListener('DOMContentLoaded', function () {

  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  // Update counter
  document.querySelectorAll('.wishlist-counter').forEach(el => {
    el.textContent = wishlist.length;
  });

  // Mark active buttons
  document.querySelectorAll('.wishlist-custom-action').forEach(btn => {
    if (wishlist.includes(btn.dataset.handle)) {
      btn.classList.add('active-wishlist');
    }
  });

  // Toggle wishlist add/remove
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.wishlist-custom-action');
    if (!btn || btn.dataset.page === 'wishlist-remove') return;
    e.preventDefault();

    const handle = btn.dataset.handle;
    wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
     if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
      btn.classList.remove('active-wishlist');
    } else {
      wishlist.push(handle);
      btn.classList.add('active-wishlist');
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    document.querySelectorAll('.wishlist-counter').forEach(el => {
      el.textContent = wishlist.length;
    });
  });

  // ── WISHLIST PAGE RENDERING ──
  const container = document.getElementById('wishlist-products');
  if (!container) return;

  if (wishlist.length === 0) {
    document.querySelector('.section-capture') &&
      (document.querySelector('.section-capture').style.display = 'none');
    container.innerHTML = `
      <div style="width:100%;text-align:center;padding:60px 0;">
        <h4>Your wishlist is empty. <a href="/collections/all">Continue shopping</a></h4>
      </div>`;
    return;
  }

  container.innerHTML = '<p style="padding:20px;">Loading...</p>';

  Promise.all(
    wishlist.map(handle =>
      fetch('/products/' + handle + '.js')
        .then(res => res.ok ? res.json() : null)
        .catch(() => null)
    )
  ).then(products => {
    products = products.filter(Boolean);

    if (!products.length) {
      container.innerHTML = '<h4 style="padding:20px;">No products found.</h4>';
      return;
    }

    container.innerHTML = products.map(p => {
      const image = p.featured_image ? 'https:' + p.featured_image : '';
      const price = (p.price / 100).toFixed(2);
      return `
        <div style="width:220px;border:1px solid #eee;border-radius:8px;padding:15px;text-align:center;">
          <a href="${p.url}">
            ${image ? `<img src="${image}" style="width:100%;height:180px; object-fit:contain;" alt="${p.title}">` : ''}
            <h5 style="margin:10px 0 5px;font-size:14px;">${p.title}</h5>
            <p style="color:#e44;font-weight:bold;">&#8377;${price}</p>
          </a>
          <button 
            onclick="removeWishlistItem('${p.handle}', this)"
            style="background:#333;color:#fff;border:none;padding:8px 16px;cursor:pointer;border-radius:4px;margin-top:8px;">
            ❤ Remove
          </button>
        </div>`;
    }).join('');
  });

  window.removeWishlistItem = function(handle, btn) {
    let list = JSON.parse(localStorage.getItem('wishlist')) || [];
    list = list.filter(h => h !== handle);
    localStorage.setItem('wishlist', JSON.stringify(list));
    btn.closest('div').remove();
    document.querySelectorAll('.wishlist-counter').forEach(el => {
      el.textContent = list.length;
    });
    if (list.length === 0) {
      document.querySelector('.section-capture') &&
        (document.querySelector('.section-capture').style.display = 'none');
      container.innerHTML = `
        <div style="width:100%;text-align:center;padding:60px 0;">
          <h4>Your wishlist is empty. <a href="/collections/all">Continue shopping</a></h4>
        </div>`;
    }
  };

});